export const fetchTars = async (params: any) => {
    let { endpoint, payload } = params;
    try {
        await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
    }
    catch (e) {
        console.log("Failed to get Tars", e)
    }
}
